import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { i18n } from './plugins/i18n'
import { Trans } from './plugins/Translation'
require('./helpers/directives')
import {BootstrapVue,BootstrapVueIcons} from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Styles: SCSS
import './assets/scss/droident.scss'

// axios
import axios from 'axios'
import utils from './helpers/utilities'

// Globally Registered Components
import './globalComponents.js'



Vue.prototype.$http = axios
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
Vue.prototype.$utils = utils


Vue.prototype.$toastr = require('toastr');
//require('./bootstrap');
Vue.config.productionTip = false ;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
import VueMonthlyPicker from 'vue-monthly-picker'
Vue.component('vue-monthly-picker',    VueMonthlyPicker)
;

new Vue({
  store,
  router,
  i18n,
   render: h => h(App)
}).$mount('#app')
